import React, { memo } from 'react';
import {
    Table,
    Button,
    Select,
    Switch
} from 'antd';
import {
    DeleteOutlined
} from '@ant-design/icons';
import { useTheme } from '@/components/common/ThemeProvider';

const { Option } = Select;

interface UserGroupsTabProps {
    selectedGroups: any[];
    userGroups: any[];
    isLoadingGroups: boolean;
    mode: 'create' | 'edit' | 'view';
    onAddUserGroup: (groupCode: string) => void;
    onRemoveUserGroup: (groupCode: string) => void;
    onGroupPropertyChange: (groupCode: string, prop: string, value: boolean) => void;
}

const UserGroupsTab: React.FC<UserGroupsTabProps> = memo(({
    selectedGroups,
    userGroups,
    isLoadingGroups,
    mode,
    onAddUserGroup,
    onRemoveUserGroup,
    onGroupPropertyChange
}) => {
    const { dark } = useTheme();

    console.log(userGroups);

    const availableGroups = userGroups.filter(
        g => !selectedGroups.some(sg => sg.groupCode === g.code)
    );

    const groupColumns = [
        {
            title: 'Group Name',
            key: 'groupName',
            render: (_: any, record: any) => {
                const group = userGroups.find(g => g.code === record.groupCode);
                return group ? group.name : `Group ${record.groupCode}`;
            }
        },
        {
            title: 'Can Use Freestyle',
            key: 'canUseFreestyle',
            render: (_: any, record: any) => (
                <Switch
                    checked={record.canUseFreestyle}
                    onChange={(checked) =>
                        onGroupPropertyChange(record.groupCode, 'canUseFreestyle', checked)
                    }
                    disabled={mode === 'view'}
                />
            )
        },
        {
            title: 'Default Category',
            key: 'isDefault',
            render: (_: any, record: any) => (
                <Switch
                    checked={record.isDefault}
                    onChange={(checked) =>
                        onGroupPropertyChange(record.groupCode, 'isDefault', checked)
                    }
                    disabled={mode === 'view'}
                />
            )
        },
        {
            title: 'Actions',
            key: 'actions',
            render: (_: any, record: any) => (
                <Button
                    danger
                    icon={<DeleteOutlined />}
                    onClick={() => onRemoveUserGroup(record.groupCode)}
                    size="small"
                    disabled={mode === 'view'}
                />
            )
        }
    ];

    return (
        <div className="space-y-4">
            {mode !== 'view' && (
                <div className="mb-4">
                    <h3 className={`font-semibold mb-2 ${dark ? 'text-white' : ''}`}>
                        Add User Group
                    </h3>
                    <Select
                        placeholder="Select a user group to add"
                        style={{ width: '100%' }}
                        // @ts-ignore
                        onSelect={(value: string) => onAddUserGroup(value)}
                        value={undefined}
                        loading={isLoadingGroups}
                        disabled={isLoadingGroups}
                    >
                        {availableGroups.map(group => (
                            <Option key={group.code} value={group.code}>
                                {group.name}
                            </Option>
                        ))}
                    </Select>
                </div>
            )}

            <Table
                dataSource={selectedGroups}
                columns={groupColumns}
                rowKey="groupCode"
                pagination={false}
                size="middle"
                loading={isLoadingGroups}
            />
        </div>
    );
});

UserGroupsTab.displayName = 'UserGroupsTab';

export default UserGroupsTab;
